export default __webpack_public_path__ + "static/media/nifty-capital-market.ca02a301.jpg";